import { render, staticRenderFns } from "./Bokumetsu.vue?vue&type=template&id=a2367d18&scoped=true&"
import script from "./Bokumetsu.vue?vue&type=script&lang=js&"
export * from "./Bokumetsu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/bokumetsu.scss?vue&type=style&index=0&id=a2367d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2367d18",
  null
  
)

export default component.exports